export const API_URL =
  process.env.REACT_APP_API_URL || "https://hivecloud-api-dev1.dev.hivepro.com";
// export const API_URL = "https://hivecloud-api-dev1.dev.hivepro.com";
export const HOME_PAGE = process.env.PUBLIC_URL || "/";
export const AUTH_ENABLED = true;
export const PRODUCT_NAME = "HivePro Uni5";
